// extracted by mini-css-extract-plugin
export default {"overlay":"MessageModal_overlay__cr-Un","modal":"MessageModal_modal__r5ZkK","textarea":"MessageModal_textarea__g2FcH","actions":"MessageModal_actions__2UfOx"};